import React from 'react'
import { TRACKERTYPES } from 'utils/constants'

interface Props {
  tank: any
  hideNormalStatus?: boolean
}

const ReadIcon = ({ tank, hideNormalStatus }: Props): React.ReactElement => {
  const lastUpdated = tank.info.lastUpdated
  let icon = hideNormalStatus ? null : 'green'
  let tooltipMessage = '';
  if (tank.info.lastUpdated) {
    const now = new Date()
    let delta = (now.valueOf() - lastUpdated) / 1000 / 60
    if (delta > 6 * 60) {
      icon = 'alert'
      tooltipMessage = 'Last Reading was over 6 hours ago'
    } else if (delta > 2 * 60) {
      icon = 'amber'
      tooltipMessage = 'Last Reading was between 2 and 6 hours ago'
    }
  } else {
    // if (TRACKERTYPES.includes(tank.type)) {
    //   icon = ''
    // }
    // else {
      icon = 'nosignal'
      tooltipMessage = 'Never received a reading'
    //}
  }

  if (TRACKERTYPES.includes(tank.type)) {
    icon = ''
  }

  if (!icon) return null

  return <img className="icon" src={`/images/icons/reading-${icon}.svg`} title={tooltipMessage} />
}

export default React.memo(ReadIcon)
